<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import { error_message, success_message } from "../../../state/helpers";
import { mapActions } from "vuex";
import appConfig from "@/app.config";
import { required, minLength, sameAs } from "vuelidate/lib/validators";

export default {
  page: {
    title: "Change Password",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: "Change Password",
      typeform: {
        old_password: "",
        password: "",
        confirm_password: "",
      },
    };
  },
  validations: {
    typeform: {
      old_password: {
        required,
      },
      password: {
        required,
        minLength: minLength(6),
      },
      confirm_password: {
        required,
        sameAsPassword: sameAs("password"),
      },
    },
  },
  methods: {
    ...mapActions("user", ["ChangePassword"]),
    typeForm() {
      this.$v.$touch();
      if (this.$v.typeform.$invalid) {
        return;
      } else {
        this.ChangePassword(this.typeform).then((response) => {
          console.log(response);
          if (response.data.code === 200) {
            success_message(response.data.msg);
            localStorage.removeItem("token");
            this.$router.push({ name: "login" });
          } else {
            error_message(response.data.msg);
          }
        });
      }
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" />
    <div class="row">
      <div class="col-12">
        <form action="#" @submit.prevent="typeForm">
          <!-- Change Password Start -->
          <div class="card">
            <div class="card-body">
              <p class="card-title-desc"></p>
              <div class>
                <div class="row">
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label class="control-label">Old Password</label>
                      <input
                        id="old_password"
                        name="old_password"
                        type="password"
                        v-model="$v.typeform.old_password.$model"
                        placeholder="Enter Old Password"
                        class="form-control"
                        :class="{ 'is-invalid': $v.typeform.old_password.$error }"
                      />
                      <div
                        v-if="$v.typeform.old_password.$error"
                        class="invalid-feedback"
                      >
                        <span v-if="!$v.typeform.old_password.required"
                          >Please enter old password</span
                        >
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label class="control-label">New Password</label>
                      <input
                        id="password"
                        name="password"
                        type="password"
                        v-model="$v.typeform.password.$model"
                        placeholder="Enter New Password"
                        class="form-control"
                        :class="{ 'is-invalid': $v.typeform.password.$error }"
                      />
                      <div v-if="$v.typeform.password.$error" class="invalid-feedback">
                        <span v-if="!$v.typeform.password.required"
                          >Please enter new password</span
                        >
                        <span v-if="!$v.typeform.password.minLength"
                          >Please enter minimum 6 digit</span
                        >
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label class="control-label">Re-enter New Password</label>
                      <input
                        id="confirm_password"
                        name="confirm_password"
                        type="password"
                        v-model="$v.typeform.confirm_password.$model"
                        placeholder="Re enter New Password"
                        class="form-control"
                        :class="{ 'is-invalid': $v.typeform.confirm_password.$error }"
                      />
                      <div
                        v-if="$v.typeform.confirm_password.$error"
                        class="invalid-feedback"
                      >
                        <span v-if="!$v.typeform.confirm_password.required"
                          >Please re enter your password</span
                        >
                        <span v-else-if="!$v.typeform.confirm_password.sameAsPassword"
                          >Passwords must match</span
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-6">
                  <button type="submit" class="btn btn-primary mr-1 mt-3">Update</button>
                  <b-button
                    @click="$router.go(-1)"
                    type="button"
                    variant="secondary"
                    class="mt-3"
                    >Cancel</b-button
                  >
                </div>
              </div>
            </div>
          </div>
          <!-- Change Password End -->
        </form>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>
